// import { $translate } from '@/utils/i18n';
export const nodeConfig = {
    configuration: true,
    searchList: {
        searchLeftSpan: 18,
        searchRightSpan: 6,
        unfoldState: false,
        hideDefaultBtn: true,
        advancedBtn: false
    },
    table: {
        selectBtn: true,
        clickState: true,
        leftOperation: false,
        height: 400,
        rowKey: 'id',
        columns: [
            {
                label: '节点编码',
                align: 'center',
                prop: 'nodeCode',
                width: 120
            },
            {
                label: '节点名称',
                align: 'left',
                prop: 'nodeName',
                width: 150
            },
            {
                label: '节点顺序',
                align: 'center',
                prop: 'nodeSequence',
                type: 'category',
                width: 60
            }, {
                label: '备注',
                align: 'left',
                prop: 'remark',
                width: 120
            }
        ]
    },
    showPage: false
};
